            
document.addEventListener("DOMContentLoaded", function () {
    const bnplBtns = document.querySelectorAll(".new_draft_order_bnpl"); // select all buttons with this class

    bnplBtns.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
        e.preventDefault();
        const paymentTerms = this.getAttribute("payment-terms-template");
        window.customerInfo["Payment Days"] = paymentTerms;
        $(this).text("Finalizing Order...")
        try {
            
            dpoObserver.checkout2(e, this);

            fetch("/cart/clear.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            })
            .catch(err => console.error("Failed to clear cart", err));

        } catch (err) {
            console.error("checkout2 failed:", err);
        }
    });
    });
});

